import React from 'react';
import ImagePlaceholder from 'assets/img/placeholder/image_placeholder.svg';

const Image = (props) => {
  const {
    src,
    alt = 'image',
    defaultImg = ImagePlaceholder,
    width = '100%',
    height = '100%',
    className,
  } = props;

  const [isFallback, setIsFallback] = React.useState(false);

  return (
    <img
      src={src ?? 'undefined'}
      alt={alt}
      className={className}
      style={{ objectFit: isFallback ? 'cover' : 'contain' }}
      width={width}
      height={height}
      onLoadStart={() => {
        setIsFallback(false);
      }}
      onError={({ currentTarget }) => {
        setIsFallback(true);
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = defaultImg;
      }}
    />
  );
};

export default Image;
